import React, {useState} from 'react';

interface ConfirmDeleteModalProps {
  isVisible: boolean;
  onClose: () => void;
  onConfirm: (reason?: string) => void;
  title: string;
  description: string;
  isSubmitting?: boolean;
  error?: string | null;
  hasReason?: boolean;
  btnText?: string;
}

export const ConfirmDeleteModalComponent: React.FC<ConfirmDeleteModalProps> = ({
  isVisible,
  onClose,
  onConfirm,
  title,
  description,
  isSubmitting = false,
  error,
  hasReason = false,
  btnText = 'Delete',
}) => {
  const [reason, setReason] = useState<string>('');

  return (
    <div
      className={`hs-overlay ${isVisible ? 'flex' : 'hidden'} ti-modal fixed inset-0 items-center justify-center bg-black bg-opacity-30`}
    >
      <div className="ti-modal-box modal-dialog-centered mt-0 max-h-[80vh] w-full overflow-hidden !opacity-100 ease-out hs-overlay-open:mt-7 sm:w-1/2 md:w-1/3 lg:w-1/4">
        <div className="ti-modal-content flex h-full flex-col rounded-lg bg-white shadow-lg">
          <div className="ti-modal-header flex-shrink-0 border-b p-4">
            <h6 className="modal-title !text-default text-[1rem] font-semibold dark:text-defaulttextcolor/70">
              {title}
            </h6>

            <button
              type="button"
              className="hs-dropdown-toggle !text-[1rem] !font-semibold"
              onClick={onClose}
              disabled={isSubmitting}
            >
              <span className="sr-only">Close</span>
              <i className="ri-close-line"></i>
            </button>
          </div>
          {error && (
            <div
              className="text-red-500 px-4 pt-2 text-sm"
              style={{
                color: 'red',
              }}
            >
              {' '}
              {error}
            </div>
          )}
          <div className="ti-modal-body px-6 py-4">
            <p className="text-[0.9375rem] text-gray-700 dark:text-gray-300">{description}</p>
          </div>
          {hasReason && (
            <div className="mb-4 px-4">
              <label htmlFor="deleteReason" className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
                Reason for deletion:
              </label>
              <textarea
                id="deleteReason"
                name="deleteReason"
                rows={3}
                value={reason}
                onChange={e => setReason(e.target.value)}
                className="focus:border-indigo-500 focus:ring-indigo-500 block w-full rounded-md border-gray-300 shadow-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white sm:text-sm"
                placeholder="Please provide a reason for deletion..."
              ></textarea>
            </div>
          )}
          <div className="ti-modal-footer flex flex-shrink-0 justify-end space-x-3 border-t p-4">
            <button
              type="button"
              className="ti-btn ti-btn-light align-middle"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="ti-btn bg-danger align-middle text-white"
              onClick={() => {
                if (reason) {
                  onConfirm(reason);
                } else {
                  onConfirm();
                }
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? `${btnText}ing...` : btnText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
